import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './ProgressBar.module.scss';
import { ProgressBarTestIds } from './ProgressBar.utils';
export const ProgressBar = (props)=>{
    const { completed, total, variant = 'steps', testId, className } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.progressBar, styles[variant + 'Variant'], className),
        "data-testid": testId || ProgressBarTestIds.root(),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.progressThumb,
            style: {
                width: 100 * completed / total + '%'
            },
            "data-total": total,
            "data-completed": completed,
            "data-testid": ProgressBarTestIds.thumb()
        })
    });
};
